import { memo } from 'react';
import { Box } from '@amzn/awsui-components-core';

/** Bullet `•` shown between items in a horizontal metadata row. */
export const MetaDivider = memo(function MetaDivider() {
  return (
    <Box variant="span" color="text-body-secondary">
      •
    </Box>
  );
});
